var fontFaces = [
    {
        name: 'Segoe UI',
        paths: [
            'https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-regular.woff2',
        ],
        style: { fontWeight: 400 },
    },
    {
        name: 'Segoe UI',
        paths: [
            'https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-semibold.woff2',
        ],
        style: { fontWeight: 600 },
    },
    {
        name: 'Segoe UI',
        paths: [
            'https://static2.sharepointonline.com/files/fabric/assets/fonts/segoeui-westeuropean/segoeui-bold.woff2',
        ],
        style: { fontWeight: 700 },
    },
];
export default fontFaces;
